import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  width: "100%",
  style: {"width":"100vw","background":"white","height":"93.5vh","left":"0px","top":"60px","border-top":"1px solid rgb(222, 226, 230)","z-index":"1"},
  class: "position-absolute d-flex"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "m-auto spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("iframe", {
      width: "100%",
      style: {"height":"93.5vh","left":"0px","top":"60px","border-top":"1px solid rgb(222, 226, 230)","z-index":"2"},
      class: "position-absolute",
      src: _ctx.url,
      frameborder: "0"
    }, null, 8, _hoisted_2),
    _createVNode(_component_b_link, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToBack())),
      target: "_blank",
      href: _ctx.url,
      variant: "primary",
      class: "btn btn-primary position-absolute",
      style: {"top":"67px","right":"64px","z-index":"2"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('openInBrowser')), 1)
      ], undefined, true),
      _: 1
    }, 8, ["href"]),
    _createVNode(_component_b_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToBack())),
      class: "position-absolute",
      style: {"top":"67px","right":"22px","z-index":"2"}
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ], undefined, true),
      _: 1
    })
  ]))
}